import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { AuthStore } from '../../../authentication/authStore';

@Component({
  selector: 'app-error-page',
  imports: [NzButtonModule, NzFlexModule],
  templateUrl: './error-page.html',
  styleUrl: './error-page.scss',
})
export class ErrorPage {
  private route = inject(ActivatedRoute);
  protected auth = inject(AuthStore);
  protected code = computed(() => this.route.snapshot.paramMap.get('code'));

  title = computed(() => {
    switch (this.code()) {
      case 'unauthorized':
        return '401 - Unauthorized';
      case 'forbidden':
        return '403 - Forbidden';
      case 'not-found':
        return '404 - Not Found';
      default:
        return 'Error';
    }
  });

  message = computed(() => {
    switch (this.code()) {
      case 'unauthorized':
        return 'You must log in.';
      case 'forbidden':
        return 'You don’t have access.';
      default:
        return 'Something went wrong.';
    }
  });
}
